import { render, staticRenderFns } from "./PreviewWidget.vue?vue&type=template&id=788ca1a4&scoped=true&"
import script from "./PreviewWidget.vue?vue&type=script&lang=js&"
export * from "./PreviewWidget.vue?vue&type=script&lang=js&"
import style0 from "./PreviewWidget.vue?vue&type=style&index=0&id=788ca1a4&prod&scoped=true&lang=css&"
import style1 from "./PreviewWidget.vue?vue&type=style&index=1&id=788ca1a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788ca1a4",
  null
  
)

export default component.exports